import React from "react";
import { Box, Container, Image, List, ListItem, Text } from "@chakra-ui/react";

const summitObjectives = [
	{
		id: "climate-investments",
		title:
			"India's emergence as a prime destination for climate-focused investments",
		description:
			"Explore India's growing potential in climate-focused investments and fund management.",
	},
	{
		id: "cop29-takeaways",
		title: "Key takeaways from COP29 and their implications for India",
		description:
			"Discuss the outcomes of COP29 and their impact on India's climate policies and initiatives.",
	},
	{
		id: "net-zero-transition",
		title: "Unlocking India's trillion-dollar net-zero transition opportunity",
		description:
			"Examine the vast potential for India's net-zero transition and explore strategies to capitalize on it.",
	},
	{
		id: "ifsc-climate-finance",
		title:
			"Mobilizing climate finance through IFSC as a global climate finance hub",
		description:
			"Explore how India's International Financial Services Centre (IFSC) can serve as a global hub for climate finance.",
	},
	{
		id: "renewable-energy-ev",
		title:
			"Building India's renewable energy and electric vehicle (EV) ecosystem",
		description:
			"Discuss strategies for developing India's renewable energy sector and EV infrastructure.",
	},
	{
		id: "lp-perspectives",
		title:
			"Global capital: LP perspectives on investing in climate-focused funds",
		description:
			"Gain insights from limited partners on investing in climate-focused funds globally.",
	},
	{
		id: "mdb-reforms",
		title:
			"Mobilizing private capital through MDB reforms: from millions to trillions",
		description:
			"Examine how multilateral development banks can mobilize larger amounts of private capital for climate initiatives.",
	},
	{
		id: "mobility-electrification",
		title:
			"Electrifying India's mobility: infrastructure, battery manufacturing, and innovation",
		description:
			"Discuss strategies for electrifying India's transportation sector, including infrastructure and technology innovations.",
	},
	{
		id: "power-sector-transformation",
		title: "Transforming India's power sector: from RTC to green hydrogen",
		description:
			"Explore the transition of India's power sector towards renewable technologies like green hydrogen.",
	},
	{
		id: "climate-policy-strategies",
		title: "Fostering state and national strategies for climate policy",
		description:
			"Develop and discuss state and national-level strategies for implementing effective climate policies in India.",
	},
	{
		id: "green-financial-institution",
		title:
			"Creating a National Green Financial Institution to drive sustainable finance",
		description:
			"Examine the role and potential impact of a national green financial institution in promoting sustainable finance in India.",
	},
];

const KeyDiscussions = () => (
	<Box w="full" bgColor="#EEFFF3">
		<Container maxW="container.lg">
			<Box padding={{ xs: "50px 0px", md: "60px 50px 56px" }} mt="10px">
				<Text
					fontWeight="700"
					fontSize={{ xs: "26px", md: "36px" }}
					lineHeight="130%"
					color="#197542"
					textAlign="left"
					mb="2.5rem"
					borderLeft="3px solid #197542"
					pl="10px"
				>
					Key Discussion Topics at the IVCA GreenReturns Summit 2024
				</Text>

				<List spacing={4} w={{ xs: "100%", lg: "100%" }}>
					<Text
						fontWeight="600"
						fontSize={{ xs: "14px", md: "24px" }}
						lineHeight="150%"
						mb="1rem"
						letterSpacing="0.02em"
						color="#010E04"
					>
						IVCA GreenReturns Summit 2024 will delve into critical discussions
						shaping the future of climate finance and investment in India. The
						key topics to be explored include:
					</Text>
					{summitObjectives?.map((item, idx) => (
						<ListItem
							fontSize={{ xs: "14px", md: "18px" }}
							display="flex"
							color="#46564A"
							key={idx}
						>
							<Image
								src="https://static.levocdn.com/WGLBUT82/Group7971-SvI2sFrj5o3h.png"
								width="16px"
								height="25px"
								objectFit="contain"
								mr="10px"
							/>
							{item?.description}
						</ListItem>
					))}
				</List>
			</Box>
		</Container>
	</Box>
);

export default KeyDiscussions;
